import { usePageRedirectToOrgSlug } from "@/lib/use-page-redirect-to-org-slug";

const LlamaPage = () => {
  usePageRedirectToOrgSlug();
  return <></>;
};

export default LlamaPage;
